import clsx from 'clsx'
import { Table } from 'components'
import {
	LoginReminderItem,
	LoginReminderResponse,
	ParentTableProps
} from 'interfaces'
import React, { useCallback, useMemo } from 'react'
import { Column, Row } from 'react-table'

export const ReminderPeopleTable: React.FC<
	ParentTableProps<LoginReminderResponse>
> = ({
	data,
	page,
	setPage,
	isLoading,
	setDataSelected,
	className,
	dataSelected
}) => {
	const columns = useMemo(
		(): Column<LoginReminderItem>[] => [
			{ Header: 'Name', accessor: 'name' },
			{ Header: 'Email', accessor: 'email' }
		],
		[]
	)

	const handleSelectRow = useCallback<
		(rows: Row<LoginReminderItem>[], selected: boolean) => void
	>((rows, selected) => {
		const ids = rows.map(row => {
			const partner = row.original as LoginReminderItem
			return partner.id
		})
		if (selected) {
			setDataSelected?.(prev => [...prev, ...ids])
		} else {
			setDataSelected?.(prev =>
				prev.filter(partnerId => !ids.includes(partnerId))
			)
		}
	}, [])

	return (
		<div className={clsx(className, 'flex flex-col w-full')}>
			<Table<LoginReminderItem>
				data={data?.items ?? []}
				page={page}
				columns={columns}
				customWidth={[25, 66]}
				selectionCustomWidth={0}
				bodyTableClassName="!h-[calc(100vh_-_500px)] overflow-y-auto"
				noDataMessage="No Result Found"
				justify="left"
				isFetching={isLoading}
				onPageChange={setPage}
				onRowSelect={handleSelectRow}
				rowSelected={useCallback(
					(row: { original: { id: number } }) =>
						dataSelected?.includes(row.original.id) ?? false,
					[dataSelected]
				)}
				pages={data?.size}
				customWidthOverride
				borderPrimary
			/>
		</div>
	)
}
